import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Log} from '../model/index';

@Injectable()
export class LogService {
  constructor(private http: Http) {
  }

  getAll(rowid: string = '') {

    return this.http.get('logs/list/' +rowid).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('logs/' + _id).map((response: Response) => response.json());
  }
  
  getfilesById(_id: string) {
    return this.http.get('files/getbyrowid/' + _id).map((response: Response) => response.json());
  }
  
  getfileById(_id: string) {
    return this.http.get('files/' + _id).map((response: Response) => response.json());
  }
  
  getfiledById(_id: string) {
    return this.http.get('files/showdetails/' + _id).map((response: Response) => response.json());
  }
  getfileshow(_id: string) {
    return this.http.get('files/image/' + _id).map((response: Response) => response.json());
  }
  getallCategory(screen: any)  {
      return this.http.get('filescat/all/' + screen).map((response: Response) => response.json());
  }
  
  create(catname: string ) {
        return this.http.post('filescat', catname).map((response: Response) => response.json());
   }

   deletecat(_id: string,screen: string) {
       return this.http.delete('filescat/' + _id + "/" + screen).map((response: Response) => response.json());;
   } 
   
   createfile(catname: any) {
        return this.http.post('files', catname).map((response: Response) => response.json());
   }
   clearDir() {
        return this.http.get('files/directory/clear').map((response: Response) => response.json());
   }
   
   delete(_id: string) {
        return this.http.delete('files/' + _id).map((response: Response) => response.json());
    }
    
    clearfiles() {
        return this.http.get('files/directory/clear');
   } 

}



// WEBPACK FOOTER //
// ./src/app/services/log.service.ts